import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Profile from '@/components/Profile'
import Details from '@/components/Order/Details'
import EditRemark from '@/components/Order/EditRemark'
import Index from '@/components/Index'
import Editprofile from '@/components/Editprofile'
import Barcode from '@/components/Barcode'
import BarcodeWithoutLabel from '@/components/BarcodeWithoutLabel'
import QrCode from '@/components/QrCode'
import DetailsArriving from '@/components/Order/DetailsArriving'
import SelectCompany from '@/components/Order/SelectCompany'
import Success from '@/components/Return/Success'
import EnterBarcode from '@/components/Return/EnterBarcode'
import EnterIdentity from '@/components/Return/EnterIdentity'
import EnterPIN from '@/components/Return/EnterPIN'
import Expired from '@/components/Return/Expired'
import SearchResult from '@/components/SearchResult'
import ThisMonth from '@/components/Acount/ThisMonth.vue'
import TodayLogs from '@/components/Acount/TodayLogs'
import Total from '@/components/Acount/Total'
import Month from '@/components/Acount/Month'
import SelectFlow from '@/components/SelectFlow'
import Step1Success from '@/components/Return/Step1Success'
import Step1SuccessWithoutLabel from '@/components/Return/Step1SuccessWithoutLabel'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/order/details',
      name: 'Details',
      component: Details
    },
    {
      path: '/order/edit',
      name: 'EditRemark',
      component: EditRemark
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/order/detailsarriving',
      name: 'DetailsArriving',
      component: DetailsArriving
    },
    {
      path: '/order/selectcompany',
      name: 'SelectCompany',
      component: SelectCompany
    },
    {
      path: '/editprofile',
      name: 'Editprofile',
      component: Editprofile
    },
    {
      path: '/barcode',
      name: 'Barcode',
      component: Barcode
    },
    {
      path: '/barcodeWithoutLabel',
      name: 'BarcodeWithoutLabel',
      component: BarcodeWithoutLabel
    },
    {
      path: '/qrcode',
      name: 'QrCode',
      component: QrCode
    },
    {
      path: '/return/success',
      name: 'Success',
      component: Success
    },
    {
      path: '/return/barcode',
      name: 'EnterBarcode',
      component: EnterBarcode
    },
    {
      path: '/return/identity',
      name: 'EnterIdentity',
      component: EnterIdentity
    },
    {
      path: '/return/expired',
      name: 'Expired',
      component: Expired
    },
    {
      path: '/return/pin',
      name: 'EnterPIN',
      component: EnterPIN
    },
    {
      path: '/search-result',
      name: 'SearchResult',
      component: SearchResult
    },
    {
      path: '/acount/this-month',
      name: 'ThisMonth',
      component: ThisMonth
    },
    {
      path: '/acount/total',
      name: 'Total',
      component: Total
    },
    {
      path: '/acount/month',
      name: 'Month',
      component: Month
    },
    {
      path: '/acount/today-logs',
      name: 'TodayLogs',
      component: TodayLogs
    },
    {
      path: '/selectFlow',
      name: 'SelectFlow',
      component: SelectFlow
    },
    {
      path: '/return/step1success',
      name: 'Step1Success',
      component: Step1Success
    },
    {
      path: '/return/Step1SuccessWithoutLabel',
      name: 'Step1SuccessWithoutLabel',
      component: Step1SuccessWithoutLabel
    },
  ]
})

// 导航前置守卫
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token')
  if (to.path === '/') {
    if (token === null) {
      next()
    } else {
      next({path: '/index'})
    }
  } else {
    if (token != null) {
      next()
    } else {
      next({path: '/'})
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js